// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `You must be at least ${i.age} years old`
};

const de_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Du musst mindestens ${i.age} Jahre alt sein`
};

const es_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Debes tener al menos ${i.age} años`
};

const fr_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Vous devez avoir au moins ${i.age} ans`
};

const fi_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Sinun tulee olla vähintään ${i.age} vuotta vanha`
};

const hi_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `आपकी उम्र कम से कम ${i.age} साल होनी चाहिए`
};

const ja_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `あなたは${i.age}歳以上である必要があります`
};

const nl_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Je moet minimaal ${i.age} jaar oud zijn`
};

const pt_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Você deve ter pelo menos ${i.age} anos`
};

const ro_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Trebuie să ai cel puțin ${i.age} ani`
};

const th_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `คุณต้องมีอายุอย่างน้อย ${i.age} ปี`
};

const ur_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `آپ کی عمر کم از کم ${i.age} سال ہونی چاہیے`
};

const zh_hant1_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `您必須年滿 ${i.age} 歲`
};

const da_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Du skal være mindst ${i.age} år gammel`
};

const it_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Devi avere almeno ${i.age} anni`
};

const vn_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Bạn phải ít nhất ${i.age} tuổi`
};

const ko_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `최소 ${i.age}세 이상이어야 합니다`
};

const tr_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `En az ${i.age} yaşında olmalısınız`
};

const lv_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Jums jābūt vismaz ${i.age} gadus vecam`
};

const ar_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `يجب أن يكون عمرك ${i.age} سنة على الأقل`
};

const bs_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Morate imati najmanje ${i.age} godina`
};

const sl_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Stari morate biti vsaj ${i.age} let`
};

const id_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Anda harus berusia minimal ${i.age} tahun`
};

const sv_widget_login_age_restriction = /** @type {(inputs: { age: NonNullable<unknown> }) => string} */ (i) => {
	return `Du måste vara minst ${i.age} år gammal`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ age: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_age_restriction = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_age_restriction(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_age_restriction", locale)
	if (locale === "en") return en_widget_login_age_restriction(inputs)
	if (locale === "de") return de_widget_login_age_restriction(inputs)
	if (locale === "es") return es_widget_login_age_restriction(inputs)
	if (locale === "fr") return fr_widget_login_age_restriction(inputs)
	if (locale === "fi") return fi_widget_login_age_restriction(inputs)
	if (locale === "hi") return hi_widget_login_age_restriction(inputs)
	if (locale === "ja") return ja_widget_login_age_restriction(inputs)
	if (locale === "nl") return nl_widget_login_age_restriction(inputs)
	if (locale === "pt") return pt_widget_login_age_restriction(inputs)
	if (locale === "ro") return ro_widget_login_age_restriction(inputs)
	if (locale === "th") return th_widget_login_age_restriction(inputs)
	if (locale === "ur") return ur_widget_login_age_restriction(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_age_restriction(inputs)
	if (locale === "da") return da_widget_login_age_restriction(inputs)
	if (locale === "it") return it_widget_login_age_restriction(inputs)
	if (locale === "vn") return vn_widget_login_age_restriction(inputs)
	if (locale === "ko") return ko_widget_login_age_restriction(inputs)
	if (locale === "tr") return tr_widget_login_age_restriction(inputs)
	if (locale === "lv") return lv_widget_login_age_restriction(inputs)
	if (locale === "ar") return ar_widget_login_age_restriction(inputs)
	if (locale === "bs") return bs_widget_login_age_restriction(inputs)
	if (locale === "sl") return sl_widget_login_age_restriction(inputs)
	if (locale === "id") return id_widget_login_age_restriction(inputs)
	if (locale === "sv") return sv_widget_login_age_restriction(inputs)
	return "widget_login_age_restriction"
};